var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "AnimatedIcon__icon",
    width: 96,
    height: 96,
    preserveAspectRatio: "xMinYMin",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    "data-js-controller": "PricingIcon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pricingIconTag",
    d: "M41.4 30.38l8.4 8.27A4 4 0 0 1 51 41.5V62a3 3 0 0 1-3 3H32a3 3 0 0 1-3-3V41.5a4 4 0 0 1 1.2-2.85l8.4-8.27a2 2 0 0 1 2.8 0zM40 36a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pricingClipPath"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#pricingIconTag",
    style: {
      transformOrigin: "40px 39px",
      transform: "rotate(45deg)"
    },
    "data-js-target-list": "PricingIcon.tagBacks"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "pricingIconTag",
    d: "M41.4 30.38l8.4 8.27A4 4 0 0 1 51 41.5V62a3 3 0 0 1-3 3H32a3 3 0 0 1-3-3V41.5a4 4 0 0 1 1.2-2.85l8.4-8.27a2 2 0 0 1 2.8 0zM40 36a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "pricingIconTag",
    d: "M41.4 30.38l8.4 8.27A4 4 0 0 1 51 41.5V62a3 3 0 0 1-3 3H32a3 3 0 0 1-3-3V41.5a4 4 0 0 1 1.2-2.85l8.4-8.27a2 2 0 0 1 2.8 0zM40 36a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "pricingIconTag",
    d: "M41.4 30.38l8.4 8.27A4 4 0 0 1 51 41.5V62a3 3 0 0 1-3 3H32a3 3 0 0 1-3-3V41.5a4 4 0 0 1 1.2-2.85l8.4-8.27a2 2 0 0 1 2.8 0zM40 36a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "pricingIconTag",
    d: "M41.4 30.38l8.4 8.27A4 4 0 0 1 51 41.5V62a3 3 0 0 1-3 3H32a3 3 0 0 1-3-3V41.5a4 4 0 0 1 1.2-2.85l8.4-8.27a2 2 0 0 1 2.8 0zM40 36a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
  }))), /*#__PURE__*/React.createElement("use", {
    href: "#pricingIconTag",
    fill: "#80E9FF",
    style: {
      transformOrigin: "40px 39px",
      transform: "rotate(45deg)"
    },
    "data-js-target-list": "PricingIcon.tagBacks"
  }), /*#__PURE__*/React.createElement("use", {
    className: "PricingIcon__tag",
    href: "#pricingIconTag",
    fill: "#7A73FF",
    style: {
      transformOrigin: "40px 39px"
    },
    "data-js-target-list": "PricingIcon.tagFronts"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pricingClipPath)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "PricingIcon__tag",
    href: "#pricingIconTag",
    fill: "#0048E5",
    style: {
      transformOrigin: "40px 39px"
    },
    "data-js-target-list": "PricingIcon.tagFronts"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.92831f300130cb8987c8d929e8b7e7b6.svg";
export { ForwardRef as ReactComponent };